/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CatalogSummaryModel { 
    sections: number;
    sectionsPublished: number;
    cards: number;
    cardsWithAddress: number;
    cardsWithoutAddress: number;
    cardsWithoutSection: number;
    uncovered: number;
    uncoveredNoTitle: number;
}

